/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Attribute } from './attribute';
import { BusinessObjectDataKey } from './businessObjectDataKey';
import { BusinessObjectDataStatusChangeEvent } from './businessObjectDataStatusChangeEvent';
import { StorageUnit } from './storageUnit';


/**
 * The business object data
 */
export interface BusinessObjectData { 
    /**
     * The internal Id that uniquely references the newly created Business Object Data
     */
    id?: number;
    /**
     * The Namespace to which a Business Object Format is related
     */
    namespace: string;
    /**
     * The name of the Business Object Definition to which a Business Object Format is related
     */
    businessObjectDefinitionName: string;
    /**
     * The Usage of this Business Object Format - a string describing how this format is used. Often used as a label for the Business                   Object Format. Does not have to be unique in the system, the Usage string is frequently shared across formats for multiple Business Object                   Definitions                
     */
    businessObjectFormatUsage: string;
    /**
     * A File Type known to the system that describes the file type of data stored under a Business Object Format
     */
    businessObjectFormatFileType: string;
    /**
     * The Business Object Format Version for a previously registered Business Object Format
     */
    businessObjectFormatVersion?: number;
    /**
     * The Partition Key this Business Object Data is being registered with. This must be they Partition Key specified in the Business                   Object Format                
     */
    partitionKey: string;
    /**
     * The Partition Value that this Business Object Data is associated with
     */
    partitionValue: string;
    /**
     * A list of Sub-Partition values associated with this Business Object Data
     */
    subPartitionValues?: Array<string>;
    /**
     * The numeric version of a Business Object Data. Each time a new data object is registered, the new version will be the previous                   version + 1                
     */
    version?: number;
    /**
     * *No longer in use* A boolean flag that shows whether this instance of data is the latest or not. Once a new version of data is                   registered, any previous versions will no longer be the latest                
     */
    latestVersion?: boolean;
    /**
     * The status of the Business Object Data. One of the following values: VALID, UPLOADING, PENDING_VALID, PROCESSING, INVALID,                   ARCHIVED, EXPIRED, or DELETED                
     */
    status?: string;
    /**
     * A container for the Storage Units associated with a Business Object Data
     */
    storageUnits?: Array<StorageUnit>;
    /**
     * Collection of name-value pairs. This can be used to store things such as S3 bucket names, validation flags, and custom                   user-defined meta-data about this storage. Attributes values are required for certain keys that are defined as Attribute Definitions in the                   Business Object Format                
     */
    attributes?: Array<Attribute>;
    /**
     * A list of Business Object Data parents (i.e. predecessors) that were used/needed in the creation of this data. This is used for                   data lineage. Each parent consists of the key data that uniquely defines a reference to a single Business Object Data.                
     */
    businessObjectDataParents?: Array<BusinessObjectDataKey>;
    /**
     * A list of Business Object Data children that were creation from this data. This is used for data lineage. Each child consists                   of the key data that uniquely defines a reference to a single Business Object Data.                
     */
    businessObjectDataChildren?: Array<BusinessObjectDataKey>;
    /**
     * Lists all business object data status change events for this business object data
     */
    businessObjectDataStatusHistory?: Array<BusinessObjectDataStatusChangeEvent>;
    /**
     * Indicate if this Business Object Data is under legal hold
     */
    legalHold?: boolean;
    /**
     * The retention expiration date for this business object data
     */
    retentionExpirationDate?: Date;
    /**
     * The User ID of the user who created this business object data
     */
    createdByUserId?: string;
    /**
     * The timestamp when this business object data was created on
     */
    createdOn?: Date;
    /**
     * The close-out date for the business object data
     */
    closeOutDate?: Date;
}
